import { hsl } from 'd3-color';

export const darker = (colorString?: string) => {
    if (!colorString) {
        return undefined;
    }
    const hslColor = hsl(colorString);
    return hslColor?.darker(1).formatRgb();
};
